import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box } from '@mui/material';
import { requestPasswordReset } from '../api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      await requestPasswordReset(email);
      setMessage('Если email верен, вы получите письмо с инструкциями по сбросу пароля.');
    } catch (err) {
      setError('Произошла ошибка. Пожалуйста, попробуйте еще раз.');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box 
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Забыли пароль?
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Отправить
          </Button>
          {message && <Typography color="primary">{message}</Typography>}
          {error && <Typography color="error">{error}</Typography>}
        </Box>
      </Box>
    </Container>
  );
}

export default ForgotPassword;
